import { render, staticRenderFns } from "./Placeholders.vue?vue&type=template&id=949eeb9c&scoped=true"
import script from "./Placeholders.vue?vue&type=script&lang=js"
export * from "./Placeholders.vue?vue&type=script&lang=js"
import style0 from "./Placeholders.vue?vue&type=style&index=0&id=949eeb9c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949eeb9c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('949eeb9c')) {
      api.createRecord('949eeb9c', component.options)
    } else {
      api.reload('949eeb9c', component.options)
    }
    module.hot.accept("./Placeholders.vue?vue&type=template&id=949eeb9c&scoped=true", function () {
      api.rerender('949eeb9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/emailActionList/Placeholders.vue"
export default component.exports